import { matchIsValidTel } from 'mui-tel-input';

export const isPhoneNumber = (value?: string) => (value ? matchIsValidTel(value) : true);
